module.exports = __webpack_public_path__ + "static/media/map.7572d7d3.png";